import { actionTypes } from '../actions';
import { clone } from 'ramda';

const initialState = {
  isUserSigninDialogVisible: false,
  is2FaVerificationDialogVisible: false,
  isResetPasswordDialogVisible: false,
  showLoginErrorMsg: false,
  isSignedIn: false,
  show2FaErrorMsg: false,
  showResend2FaMsg: false,
  token: '',
  twoFactorAuthToken: '',
  phone: '',
  usr: {},
  providers: [],
  // Providers
  resetPasswordStep1Active: false,
  resetPasswordStep2Active: false,
  isSendingTempPasswordEmail: false,
  showInvalidEmailErrorMsg: false,
  activeRecord: {},
  shouldReloadPracticeData: false,
  appAlerts: [],
  notificationsCount: 0,
  notifications: [],
  showChatIconBadge: false,
  showDmDrawer: false,
  dmUsers: [],
  activeDmUser: '',
  activeDmMessages: [],
  activeDm: {},
  alertSenderUserNames: []
};

export default function (state = initialState, action) {
  switch (action.type) {
    case actionTypes.toggleUserSigninDialog:
      return {
        ...state,
        isUserSigninDialogVisible: action.payload,
        showLoginErrorMsg: false
      };
    case actionTypes.toggleResetPasswordDialog:
      return {
        ...state,
        isResetPasswordDialogVisible: !state.isResetPasswordDialogVisible,
        isUserSigninDialogVisible: false,
        resetPasswordStep1Active: !state.isResetPasswordDialogVisible,
        resetPasswordStep2Active: false
      };
    case actionTypes.toggle2FaVerificationDialog:
      return {
        ...state,
        is2FaVerificationDialogVisible: action.payload
      };
    case actionTypes.initiateSignin:
      return {
        ...state,
        isUserSigninDialogVisible: false,
        is2FaVerificationDialogVisible: action.payload.success,
        showLoginErrorMsg: false,
        phone: action.payload.phone
      };
    case actionTypes.signinFailed:
      return {
        ...state,
        showLoginErrorMsg: true
      };
    case actionTypes.resend2Fa:
      return {
        ...state,
        showResend2FaMsg: true
      };
    case actionTypes.finalizeSignIn: {
      const usr = JSON.parse(action.payload);
      const today = new Date();
      localStorage.setItem('scheduleDate', today.getDate());
      localStorage.setItem('scheduleMonth', today.getMonth());
      localStorage.setItem('scheduleYear', today.getFullYear());
      localStorage.setItem('scheduleEndDate', today.getDate());
      localStorage.setItem('scheduleEndMonth', today.getMonth());
      localStorage.setItem('scheduleEndYear', today.getFullYear());
      return {
        ...state,
        isUserSigninDialogVisible: false,
        is2FaVerificationDialogVisible: false,
        isSignedIn: true,
        notificationsCount: usr.notificationsCount,
        // showChatIconBadge: usr.showChatIconBadge ? usr.showChatIconBadge : false,
        usr
      };
    }
    case actionTypes.hideLoginErrorMsg:
      return {
        ...state,
        showLoginErrorMsg: false
      };
    case actionTypes._2faVerificationFailed:
      return {
        ...state,
        show2FaErrorMsg: true
      };
    case actionTypes.hide2FaErrorMsg:
      return {
        ...state,
        show2FaErrorMsg: false
      };
    case actionTypes.isSignedIn: {
      const usr = JSON.parse(localStorage.getItem('usr'));
      if (action.payload.success) {
        return {
          ...state,
          isSignedIn: action.payload.success,
          notificationsCount: usr.notificationsCount,
          // showChatIconBadge: action.payload.showChatIconBadge ? action.payload.showChatIconBadge : false,
          usr
        };
      }
      // Reset Schedule grid date range on session expiry
      const today = new Date();
      localStorage.setItem('scheduleDate', today.getDate());
      localStorage.setItem('scheduleMonth', today.getMonth());
      localStorage.setItem('scheduleYear', today.getFullYear());
      localStorage.setItem('scheduleEndDate', today.getDate());
      localStorage.setItem('scheduleEndMonth', today.getMonth());
      localStorage.setItem('scheduleEndYear', today.getFullYear());

      if (window.location.href !== `${window.location.origin}/`) {
        window.location = window.location.origin;
      }

      return {
        ...state,
        isSignedIn: action.payload.success
      };
    }
    case actionTypes.logout: {
      localStorage.removeItem('twoFactorAuthToken');
      localStorage.removeItem('usr');
      localStorage.removeItem('usernameOrEmail');
      localStorage.removeItem('token');
      localStorage.removeItem('isSignedIn');
      localStorage.removeItem('scheduleDate');
      localStorage.removeItem('scheduleMonth');
      localStorage.removeItem('scheduleYear');
      localStorage.removeItem('scheduleEndDate');
      localStorage.removeItem('scheduleEndMonth');
      localStorage.removeItem('scheduleEndYear');
      localStorage.removeItem('appLocs');
      localStorage.removeItem('lastBookmark');
      localStorage.getItem('practice', '');
      localStorage.getItem('provider', '');
      localStorage.getItem('selectedPractice', '');

      if (action.payload) {
        const newId = `${state.appAlerts.length + Math.floor(Math.random() * 100)}`;
        action.payload.id = newId;
        localStorage.setItem('alerts', JSON.stringify(action.payload));
      }
      // history.push('/');
      window.location = window.location.origin;
      return {
        ...state,
        isUserSigninDialogVisible: false,
        is2FaVerificationDialogVisible: false,
        isSignedIn: false,
        showResend2FaMsg: false,
        show2FaErrorMsg: false,
        usr: {},
        phone: '',
        showLoginErrorMsg: false
      };
    }
    case actionTypes.updateBanner:
      return {
        ...state,
        usr: JSON.parse(action.payload.usr)
      };
    case actionTypes.updatePracticeBanner:
      // location.reload();
      return {
        ...state,
        shouldReloadPracticeData: true
      };
    case actionTypes.updatePracticeAvatar:
      // location.reload();
      return {
        ...state,
        shouldReloadPracticeData: true
      };
    case actionTypes.updatePracticeProfile:
      // location.reload();
      return {
        ...state,
        shouldReloadPracticeData: true
      };
    case actionTypes.togglePracticeDataReloadFlag:
      return {
        ...state,
        shouldReloadPracticeData: action.payload
      };
    case actionTypes.updateAvatar:
      return {
        ...state,
        usr: JSON.parse(action.payload.usr)
      };
    case actionTypes.updateProfile:
      return {
        ...state,
        usr: JSON.parse(action.payload.usr)
      };
    case actionTypes.reloadData:
      return {
        ...state,
        usr: action.payload
      };
    case actionTypes.addProvider:
      return {
        ...state,
        providers: state.providers.concat(action.payload.provider)
      };
    case actionTypes.addFacility:
      return { ...state };
    case actionTypes.addPractice:
      return { ...state };
    case actionTypes.getProviders:
      return {
        ...state,
        providers: [].concat(action.payload.providers)
      };
    case actionTypes.initiateResendTempPasswordEmail:
      return {
        ...state,
        isSendingTempPasswordEmail: action.payload
      };
    case actionTypes.sendTempPassword:
      return {
        ...state,
        showInvalidEmailErrorMsg: action.payload.isEmailInvalid,
        resetPasswordStep1Active: !action.payload.success,
        resetPasswordStep2Active: action.payload.success
      };
    case actionTypes.resendTempPassword:
      return {
        ...state,
        isSendingTempPasswordEmail: false,
        showInvalidEmailErrorMsg: false,
        resetPasswordStep1Active: false,
        resetPasswordStep2Active: true
      };
    case actionTypes.resetPassword:
      return {
        ...state,
        showLoginErrorMsg: false,
        isUserSigninDialogVisible: true,
        is2FaVerificationDialogVisible: false,
        isResetPasswordDialogVisible: false,
        resetPasswordStep1Active: false,
        resetPasswordStep2Active: false,
        showInvalidEmailErrorMsg: false
      };
    // TODO: Delete actionTypes.initiateProviderSignIn reducer
    case actionTypes.initiateProviderSignIn:
      return {
        ...state,
        isUserSigninDialogVisible: false,
        is2FaVerificationDialogVisible: action.payload.success,
        showLoginErrorMsg: false,
        phone: action.payload.phone
      };
    case actionTypes.providerSigninFailed:
      return {
        ...state,
        showLoginErrorMsg: true
      };
    case actionTypes.updateProviderBanner:
      return {
        ...state,
        usr: JSON.parse(action.payload.usr)
      };
    case actionTypes.updateProviderAvatar:
      return {
        ...state,
        usr: JSON.parse(action.payload.usr)
      };
    case actionTypes.setActiveRecord:
      return {
        ...state,
        activeRecord: action.payload
      };
    case actionTypes.addAppAlert: {
      const newId = `${state.appAlerts.length + Math.floor(Math.random() * 100)}`;
      action.payload.id = newId;
      return {
        ...state,
        appAlerts: state.appAlerts.concat(action.payload)
      };
    }
    case actionTypes.addAppAlertWithStateReset: {
      const {
        alert,
        stateReset = {}
      } = action.payload;
      alert.id = Math.random().toString(36);
      return {
        ...state,
        appAlerts: state.appAlerts.concat(alert),
        ...stateReset
      };
    }
    case actionTypes.deleteAppAlert:
      return {
        ...state,
        appAlerts: state.appAlerts.filter((el) => {
          return el.id !== action.payload;
        })
      };
    case actionTypes.hideAppAlert:
      return {
        ...state,
        appAlerts: state.appAlerts.map((el) => {
          if (el.id === action.payload) {
            el.showAlert = false;
          }

          return el;
        })
      };
    case actionTypes.getNotifications:
      return {
        ...state,
        notifications: action.payload
      };
    case actionTypes.setNotificationsCount: {
      const usr = Object.assign(state.usr, { notificationsCount: action.payload });
      localStorage.setItem('usr', JSON.stringify(usr));
      return {
        ...state,
        notificationsCount: usr.notificationsCount,
        usr
      };
    }
    case actionTypes.clearChatBadge:
      return {
        ...state,
        showChatIconBadge: false
      };
    case actionTypes.toggleDmDrawer:
      if (action.payload) {
        return {
          ...state,
          showDmDrawer: action.payload,
        };
      } else {
        return {
          ...state,
          showDmDrawer: action.payload,
          activeDmUser: '',
          activeDmMessages: [],
          activeDm: {},
          alertSenderUserNames: []
        };
      }
    case actionTypes.getUsersForDms:
      return {
        ...state,
        dmUsers: action.payload
      };
    case actionTypes.selectDmUser: {
      let msgs = [];
      if (action.payload.dms && action.payload.dms.messages && Array.isArray(action.payload.dms.messages)) {
        msgs = action.payload.dms.messages;
      }
      let updatedAlertSenderUserNames = clone(state.alertSenderUserNames);
      updatedAlertSenderUserNames = updatedAlertSenderUserNames.filter(el => el !== action.payload.recipientUserName);
      return {
        ...state,
        alertSenderUserNames: updatedAlertSenderUserNames,
        activeDmUser: action.payload.recipientId,
        activeDmMessages: msgs.reverse(),
        activeDm: action.payload.dms
      };
    }
    case actionTypes.postMessageToDM: {
      const updatedActiveDmMessages = clone(state.activeDmMessages);
      updatedActiveDmMessages.unshift(action.payload);
      return {
        ...state,
        activeDmMessages: updatedActiveDmMessages
      };
    }
    case actionTypes.updateChat: {
      const { dmId, lastMessage } = action.payload;
      if (state.activeDm._id === dmId) {
        const updatedActiveDmMessages = clone(state.activeDmMessages);
        updatedActiveDmMessages.unshift(lastMessage);
        return {
          ...state,
          activeDmMessages: updatedActiveDmMessages
        };
      } else {
        const { senderUserName, senderDisplayName, msg } = lastMessage;
        let updatedAlertSenderUserNames = clone(state.alertSenderUserNames);
        updatedAlertSenderUserNames = updatedAlertSenderUserNames.concat(senderUserName);
        return {
          ...state,
          showChatIconBadge: true,
          alertSenderUserNames: updatedAlertSenderUserNames,
          appAlerts: state.appAlerts.concat({
            id: `${state.appAlerts.length + Math.floor(Math.random() * 100)}`,
            headerText: `Message from ${senderDisplayName}`,
            headerIcon: 'fa fa-info-circle',
            bodyText: msg,
            showAlert: true,
            autoDismiss: true,
            autoDismissTime: 5000
          })
        };
      }
    }
    default:
      return state;
  }
}
